module.exports = __webpack_public_path__ + "static/media/password-icon-error.4e293d0d.png";